module.exports = __webpack_public_path__ + "media/images/logo-section-image-1cb1983651e1e840f05a74830038abc8.jpg";